"use client";

import { PropertyCard } from "@/components/properties/property-card";

interface CommunityPropertiesProps {
    communityName: string;
    properties: any[]; // Using any[] for simplicity with existing data structure, ideally type this from lib/data
}

export function CommunityProperties({ communityName, properties }: CommunityPropertiesProps) {
    if (properties.length === 0) return null;

    return (
        <section className="py-24 bg-background">
            <div className="container mx-auto px-6 md:px-12">
                <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6">
                    <div>
                        <span className="text-xs font-bold tracking-[0.3em] text-secondary uppercase mb-4 block">
                            Real Estate
                        </span>
                        <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-primary leading-[0.9]">
                            Properties in <br /> <span className="italic text-primary/50">{communityName}</span>
                        </h2>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
                    {properties.map((property) => (
                        <PropertyCard key={property.id} property={property} />
                    ))}
                </div>
            </div>
        </section>
    );
}
